
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestsellers",
      function () {
        return require("private-next-pages/bestsellers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestsellers"])
      });
    }
  